import React from 'react';
import { useLocation } from 'react-router-dom';
import { getNavbarConfig } from './navbarConfig';

/**
 * Dynamic Navbar component that renders the appropriate navbar based on the current route
 */
const DynamicNavbar = () => {
  const location = useLocation();
  const config = getNavbarConfig(location.pathname);

  // If no navbar is configured, don't render anything
  if (!config || !config.navbar) {
    return null;
  }

  const NavbarComponent = config.navbar;
  const navbarProps = config.navbarProps ? config.navbarProps() : {};

  // eslint-disable-next-line react/jsx-props-no-spreading
  return <NavbarComponent {...navbarProps} />;
};

export default DynamicNavbar;
